<script setup lang="ts">
  import { NATIVE_NAVIGATION_ITEMS } from "@/constants/navigation/navigation.ts"
  import useRouteTitle from "@/lib/useRouteTitle.ts"
  import NativePageHeader from "@/components/native/NativePageHeader.vue"
  import NativeNavbar from "@/components/native/navbar/NativeNavbar.vue"

  import MaintenanceBanner from "@/views/maintenance-banner/MaintenanceBanner.vue"

  const { title } = useRouteTitle()
</script>

<template>
  <main id="native-layout" class="bottom-bar-padding relative h-svh w-svw">
    <div
      class="bottom-bar-padding container flex min-h-full flex-col overflow-y-auto p-6"
      :class="{ 'px-0': $route.meta?.fullWidth }"
    >
      <NativePageHeader v-if="title" :title="title" class="mb-7" />
      <MaintenanceBanner class="mb-4 sm:mb-6" />

      <slot />
    </div>

    <NativeNavbar
      :navigation-items="NATIVE_NAVIGATION_ITEMS"
      class="fixed inset-x-0 bottom-0 mt-auto"
    />
  </main>
</template>

<style>
  #native-layout {
    --navbar-height: 90px;
  }

  .bottom-bar-padding {
    padding-bottom: var(--navbar-height);
  }

  main#native-layout nav {
    height: var(--navbar-height);
  }
</style>
